import { TableData } from "./table/TableData";
import { TableWrapper } from "./wrappers/TableWrapper";

export interface CertificateType extends TableData {
    id: number,
    name: string,
    serialNumber: string,
    createdBy: string,
    lastModifiedBy: string,
    expiryDate: string,
    certificateAuthority: string,
    status: string,
    certStatus?: string,
    certType: string,
    siteId: number,
    site: string,
    revoke: string
}

export interface CardTypeWrapper extends TableWrapper {
    rows: CertificateType[];
}

export interface CertificateDetailsType {
    id: number;
    name: string;
    serialNumber: string;
    commonName: string;
    expiresOn: string;
    issuedOn: string;
    issuerCommonName: string;
    issuerOrganisation: string;
    issuerOrganisationalUnit: string;
    organisation: string;
    organisationalUnit: string;
    publicKeyFingerprintAlgorithm: string;
    publicKeyFingerprintParams: string;
    publicKeyFingerprintModulus: string;
    publicKeyFingerprintExponent: string;
    certificateFingerprintAlgorithm: string;
    certificateFingerprintModulus: string;
    subjectAlternativeName: string;
    ksCertificateStatus?: string;
    encryptionType?: string;
    shaAlgorithm?: string;
    curve?: string;
    keySize?: string;
    isCaCertificate: boolean;
    caCertificateId: number;
    certificateTypeId: number;
    certificateTypeName?: string;
    isRevoked: boolean;
}

export const VALIDITY_IN_OPTION = {
    DAYS: "1",
    YEARS: "2"
}
